import React from "react";
import ReactDOM from "react-dom";
import {QSpaceFeaturedContent} from "../components/QSpaceFeaturedContent";

export const insertQSpaceFeaturedContent = () => {
  const apps = document.querySelectorAll('[data-fqxi-type="qspace-featured-content"]');

  if (apps.length === 0) {
    return;
  }

  apps.forEach((element) => {
    ReactDOM.render(<QSpaceFeaturedContent />, element);
  });
};
